import styled from 'styled-components';

export const AccessContainer = styled.section`
  margin-bottom: 30px;
  
  @media (min-width: 768px) {
    max-width: 280px;
  }
  
  @media (min-width: 1024px) {
    max-width: none;
    
    form {
      display: flex;
      align-items: flex-end;
    }
  }
`;

export const AccessHeading = styled.h2`
  margin: 0;
  margin-bottom: 25px;
  padding: 0;
  
  font-size: 22px;
  line-height: 1;
  
  @media (min-width: 768px) {
    margin-bottom: 35px;
    font-size: 24px;
  }
`;

export const AccessList = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  
  li {
    margin-bottom: 25px;
  }
  
  p {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;
    
    font-size: 14px;
    line-height: 1;
    
    & + div {
      border-radius: 6px;
    }
  }
  
  @media (min-width: 1024px) {
    display: flex;
    
    li {
      flex-grow: 1;
      margin-bottom: 0;
      margin-right: 35px;
    }
  }
`;

export const AccessButton = styled.div`
  button {
    padding-left: 55px;
    padding-right: 55px;
  }
`;
